module.exports = __webpack_public_path__ + "dashboard.png?85fdfd161c935b896e00890cb4f48fe1";